// Mock data for FAVOR HCS Psychiatric Clinic

export const clinicInfo = {
  name: "FAVOR HCS",
  tagline: "Child & Adult Psychiatry",
  phone: "(281) 886-8595",
  fax: "(281) 884-3616",
  email: "admin@favorhealthcaresvcs.com",
  address: "9816 Memorial Blvd, Humble, Texas 77338",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_56761657-8c15-4313-94b8-dd6eb8b542e6/artifacts/pcsgqfvu_Favor_HCS_Logo_updated%20%281%29.png"
};

export const providerInfo = {
  name: "Tawa Raji, PMHNP",
  credentials: "Board-Certified Psychiatric Mental Health Nurse Practitioner",
  experience: "Almost 20 years of clinical experience",
  approach: "Integrative and client-centered approach",
  description: "My approach is client-centered. I like to listen to my clients and encourage them to participate in their care. I believe in building a good rapport with my clients and providing a safe space for them to feel comfortable expressing their emotional needs. I like to provide supportive and compassionate care to promote mental wellness and empowerment.",
  philosophy: "I believe in meeting people where they are, working closely with them to achieve their goals emotionally, and helping them build better and healthier relationships with family and friends. Most importantly, I teach them to love and see the value in themselves.",
  image: "https://images.pexels.com/photos/7089044/pexels-photo-7089044.jpeg"
};

export const services = [
  {
    id: 1,
    title: "ADD/ADHD",
    description: "We will help you improve your life and manage your condition.",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1537655780520-1e392ead81f2",
    learnMoreUrl: "https://www.cdc.gov/adhd/index.html"
  },
  {
    id: 2,
    title: "Depression",
    description: "Achieve healing and build a meaningful life with our help.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773",
    learnMoreUrl: "https://www.nimh.nih.gov/health/topics/depression"
  },
  {
    id: 3,
    title: "Anxiety",
    description: "Learn to manage your worries and find peace within yourself.",
    icon: "Wind",
    image: "https://images.unsplash.com/photo-1618425977996-bebc5afe88f9",
    learnMoreUrl: "https://www.nimh.nih.gov/health/topics/anxiety-disorders"
  },
  {
    id: 4,
    title: "PTSD",
    description: "We will help you cope with the past and live your best today.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1604881991720-f91add269bed",
    learnMoreUrl: "https://www.ptsd.va.gov/understand/what/index.asp"
  },
  {
    id: 5,
    title: "Bipolar Disorder",
    description: "Comprehensive treatment to help you achieve stability and balance.",
    icon: "Activity",
    image: "https://images.pexels.com/photos/7579183/pexels-photo-7579183.jpeg",
    learnMoreUrl: "https://www.nimh.nih.gov/health/topics/bipolar-disorder"
  },
  {
    id: 6,
    title: "Child & Adolescent Services",
    description: "Specialized care for children and teens with compassion and understanding.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1770096679844-57ca92c2b64b",
    learnMoreUrl: "https://www.aacap.org/AACAP/Families_and_Youth/Facts_for_Families/FFF-Guide/FFF-Guide-Home.aspx"
  }
];

export const insuranceProviders = [
  { 
    name: "Aetna", 
    logo: "aetna",
    website: "https://www.aetna.com"
  },
  { 
    name: "Magellan Health", 
    logo: "magellan",
    website: "https://www.magellanhealth.com"
  },
  { 
    name: "Amerigroup", 
    logo: "amerigroup",
    website: "https://www.myamerigroup.com"
  },
  { 
    name: "Blue Cross Blue Shield", 
    logo: "bcbs",
    website: "https://www.bcbs.com"
  },
  { 
    name: "Cigna", 
    logo: "cigna",
    website: "https://www.cigna.com"
  },
  { 
    name: "Humana", 
    logo: "humana",
    website: "https://www.humana.com"
  },
  { 
    name: "Medicare", 
    logo: "medicare",
    website: "https://www.medicare.gov"
  },
  { 
    name: "Molina Healthcare", 
    logo: "molina",
    website: "https://www.molinahealthcare.com"
  },
  { 
    name: "Oscar Health", 
    logo: "oscar",
    website: "https://www.hioscar.com"
  },
  { 
    name: "Superior HealthPlan", 
    logo: "superior",
    website: "https://www.superiorhealthplan.com"
  },
  { 
    name: "Tricare", 
    logo: "tricare",
    website: "https://www.tricare.mil"
  },
  { 
    name: "UnitedHealthcare", 
    logo: "united",
    website: "https://www.uhc.com"
  },
  { 
    name: "First Health", 
    logo: "firsthealth",
    website: "https://www.firsthealth.com"
  },
  { 
    name: "Wellcare", 
    logo: "wellcare",
    website: "https://www.wellcare.com"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Experienced Care",
    description: "Nearly 20 years of expertise in psychiatric mental health care",
    icon: "Award"
  },
  {
    id: 2,
    title: "Client-Centered Approach",
    description: "We listen, collaborate, and empower you in your healing journey",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Safe & Supportive",
    description: "A comfortable space where you can express your emotional needs freely",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Holistic Treatment",
    description: "Integrative approach addressing mind, body, and relationships",
    icon: "Sparkles"
  }
];

export const callToActions = [
  {
    id: 1,
    title: "Send a Referral",
    description: "Connect us to your friends who might need our services.",
    icon: "UserPlus",
    action: "referral"
  },
  {
    id: 2,
    title: "Set an Appointment",
    description: "Begin your journey towards a better you.",
    icon: "Calendar",
    action: "appointment"
  },
  {
    id: 3,
    title: "Insurance Accepted",
    description: "Check out the insurances we accept.",
    icon: "FileText",
    action: "insurance"
  }
];

// Mock API responses
export const mockAppointments = [];
export const mockReferrals = [];
export const mockContactMessages = [];
